import { Eye, Printer } from 'react-feather';
import PageLayout from '../../../components/PageLayout';
import {
  formatDate,
  getQueryString,
  limitOptions,
  makeDropdownOptions,
} from '../../../utils/common.util';
import useSWR from 'swr';
import { useState } from 'react';
import PaymentsReportsModal from './PaymentsReportsModal';
import {
  DatePicker,
  DatePickerInput,
  Pagination,
  Select,
  SelectItem,
} from 'carbon-components-react';
import PrintOutHead from '../../../components/PrintOutHead';
import { PrintView } from '../../../components/PrintView/print-view.component';
import CustomButton from '../../../components/custom-button/custom-btn.component';
import { useUrlState } from '../../../utils/useUrlState';

const initialData = {
  dateFrom: '',
  dateTo: '',
  schoolId: '',
  skip: 0,
  take: 10,
  status: '',
};

export default function UnbilledSchoolsReport() {
  const [isOpen, setIsOpen] = useState('');
  const [query, setQuery] = useUrlState(initialData);

  const { data, isLoading, error } = useSWR(
    `school/billing-report?${getQueryString({ ...query, billed: false })}`,
  );

  // const entries = dailySummaryData?.entries ?? [];
  const entries = data?.response ?? [];

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Admin', to: '/admin' },
        { label: `Unbilled Schools Report`, active: true },
      ]}
      title={
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: '30px' }}
        >
          <h1 className="h-20">Unbilled Schools Report</h1>{' '}
          <button
            className="text-12 text-primary d-flex align-items-center font-bold pointer clean-btn "
            style={{ gap: '4px' }}
            onClick={() => setIsOpen('reports')}
          >
            <Eye size="14" strokeWidth="2px" />
            <span>VIEW OTHER REPORTS</span>
          </button>
        </div>
      }
      isLoading={isLoading}
    >
      {/* FILTERS  */}
      {/* <p className="mt-20 text-12">
        Select at least a start and end dates to show report.
      </p> */}
      <div className="mt-10 card-row-3">
        <DatePicker
          dateFormat="Y-m-d"
          datePickerType="single"
          id="start-date-picker"
          maxDate={new Date().toISOString().split('T')[0]}
          onChange={(value) => {
            if (value.length > 0) {
              setQuery({
                dateFrom: [
                  value[0].getFullYear(),
                  ('0' + (value[0].getMonth() + 1)).slice(-2),
                  ('0' + value[0].getDate()).slice(-2),
                ].join('-'),
              });
            } else setQuery({ dateFrom: '' });
          }}
          onClose={(value) => {}}
        >
          <DatePickerInput
            className="start-date"
            id="start-date"
            name="dateFrom"
            labelText="Start Date"
            value={query.dateFrom}
            max={new Date().toISOString().split('T')[0]}
            // pattern="d{1,2}/d{4}"
            pattern="\d{4}-\d{2}-\d{2}"
            autoComplete="off"
            placeholder="YYYY-MM-DD"
            type="text"
            onChange={(e) => setQuery({ dateFrom: e.target.value })}
          />
        </DatePicker>
        <DatePicker
          dateFormat="Y-m-d"
          datePickerType="single"
          id="end-date-picker"
          // minDate={
          //   new Date(query.dateFrom ?? '').toISOString().split('T')[0]
          // }
          maxDate={new Date().toISOString().split('T')[0]}
          onChange={(value) => {
            if (value.length > 0) {
              setQuery({
                dateTo: [
                  value[0].getFullYear(),
                  ('0' + (value[0].getMonth() + 1)).slice(-2),
                  ('0' + value[0].getDate()).slice(-2),
                ].join('-'),
              });
            } else setQuery({ dateTo: '' });
          }}
          onClose={(value) => {}}
        >
          <DatePickerInput
            className="end-date"
            id="end-date"
            name="dateTo"
            labelText="End Date"
            value={query.dateTo}
            max={new Date().toISOString().split('T')[0]}
            // pattern="d{1,2}/d{4}"
            pattern="\d{4}-\d{2}-\d{2}"
            autoComplete="off"
            placeholder="YYYY-MM-DD"
            type="text"
            onChange={(e) => setQuery({ dateTo: e.target.value })}
          />
        </DatePicker>
        <Select
          labelText="Status"
          onChange={(e) => setQuery({ status: e.target.value })}
          value={query.status}
        >
          <SelectItem value="" text="All" />
          {makeDropdownOptions(['ACTIVATED', 'DEACTIVATED'])?.map((item) => (
            <SelectItem key={item.value} value={item.value} text={item.label} />
          ))}
        </Select>
      </div>

      <div className="mt-20">
        {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}
        {entries?.length > 0 && (
          <>
            <PrintOutHead
              title={`Unbilled Schools Report`}
              headings={[
                {
                  label: 'Date Range',
                  value: query.dateFrom
                    ? `${formatDate(query.dateFrom)} - ${formatDate(
                        query.dateTo,
                      )} `
                    : '-',
                },
                {
                  label: 'Status',
                  value: query.status,
                },
              ]}
            />
            <PrintView>
              <div style={{ overflow: 'auto' }}>
                <table className="bx--data-table table-white">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>School</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entries.map((entry) => {
                      return (
                        <tr key={entry.id}>
                          <td>{entry.id}</td>
                          <td>{entry.name}</td>
                          <td>
                            {entry.deactivated
                              ? 'DEACTIVATED'
                              : entry.verified && !entry.dateActivated
                                ? 'PENDING ACTIVATION'
                                : entry.dateActivated
                                  ? 'ACTIVATED'
                                  : 'PENDING VERIFICATION'}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </PrintView>
            <Pagination
              backwardText="Previous page"
              forwardText="Next page"
              page={Number(query.skip) + 1}
              pageNumberText="Page Number"
              pageSize={Number(query.take)}
              pageSizes={limitOptions(data?.paginationInfo?.totalCount)}
              totalItems={data?.paginationInfo?.totalCount}
              onChange={(value) =>
                setQuery({ skip: value.page - 1, take: value.pageSize })
              }
            />
          </>
        )}
        {entries?.length === 0 && (
          <p className="text-14 mt-30 text-grey">No data available.</p>
        )}

        {entries?.length > 0 && (
          <div
            className="mt-30"
            style={{
              display: 'flex',
              justifySelf: 'end',
              gap: '20px',
              alignItems: 'center',
            }}
          >
            <CustomButton classes="secondary" onClick={() => window.print()}>
              <Printer size="16" strokeWidth="2px" /> &nbsp; Print
            </CustomButton>
          </div>
        )}
      </div>

      <PaymentsReportsModal
        isOpen={isOpen === 'reports'}
        closeModal={() => setIsOpen('')}
      />
    </PageLayout>
  );
}
